
import Popup from 'vux/src/components/popup/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Badge from 'vux/src/components/badge/index.vue'

import banner from '@/assets/mail-banner.png'
import imgup from '@/assets/upload_img.png'
import icoLY from '@/assets/ico-ly.png'
import icoDel from '@/assets/ico-del.png'
import { getDealList, getDealLeadList, getDealLeadList2 } from '@/api/youzheng.js'
import Storage from '@/storage'
import store from '@/store'
import Scroll from '@/components/scroller'
import config from '@/config/index'
export default {
name: 'myEmail',
props: ['mydeal'],
data () {
return {
tablist: [{
id: 0,
title: '待处理'
}, {
id: 1,
title: '已处理'
}],
icoLY: icoLY,
icoDel: icoDel,
notFirstLoad: false,
loadMoreDom: null,
listDom: null,
declareList: [],
page: 1,
rows: 10,
upimglist: [],
select: this.$route.params.tabIndex,
accounttype: this.$store.state.user.personObj.accounttype
}
},
components: {
Popup,
Group,
XButton,
Tab,
TabItem,
Flexbox,
FlexboxItem,
Scroll,
Badge
},
computed: {
accountid () {
return this.$store.state.user.accountid
},
userid () {
return this.$store.state.user.userid
}
},
watch: {
select: function (nval, onav) {
this.declareList = []
this.refresh()
}
},
mounted () {
this.loadMoreDom = this.$el.querySelector('.load-more')
this.listDom = this.$el.querySelector('.list-scroll')
},
methods: {
getlist (type, done) {

if (this.accounttype === 3) {
if (this.select == 0) {

getDealLeadList2({
accountid: this.accountid,
owner_type: config.owner_type,
sourcetype: 1,
page: this.page,
rows: this.rows
}).then(res => {
if (type === 'refresh') {
this.declareList = []
this.listDom.scrollTop = 0
}
if (res.returnValue.list !== '' && res.returnValue.list.length > 0) {
res.returnValue.list.forEach(item => {
this.declareList.push({
createdate: item.createdate,
title: item.title,
id: item.id,
status: item.status,
statusNAME: item.statusNAME,
dealmsg: item.dealmsg,
dealdate: item.dealdate
})
if (item.dealfileids && item.dealfileids != '') {
let arr = item.dealfileids.split(';')
arr.forEach(i => {
this.upimglist.push({ i })
})
}
})
}
if (res.returnValue.count === 0) {
this.notFirstLoad = true
} else {
this.notFirstLoad = false
}
if (res.returnValue.list.length === 0 || res.returnValue.count < this.rows) {
this.loadMoreDom.innerText = '我也是有底线的～o～'
setTimeout(() => {
this.loadMoreDom.style.display = 'none'
}, 2000)
}
done && done()
})
} else {

getDealLeadList({
accountid: this.accountid,
owner_type: config.owner_type,
sourcetype: 1,
page: this.page,
rows: this.rows
}).then(res => {
if (type === 'refresh') {
this.declareList = []
this.listDom.scrollTop = 0
}
if (res.returnValue.list !== '' && res.returnValue.list.length > 0) {
res.returnValue.list.forEach(item => {
this.declareList.push({
createdate: item.createdate,
title: item.title,
id: item.id,
status: item.status,
statusNAME: item.statusNAME,
dealmsg: item.dealmsg,
dealdate: item.dealdate
})
if (item.dealfileids && item.dealfileids != '') {
let arr = item.dealfileids.split(';')
arr.forEach(i => {
this.upimglist.push({ i })
})
}
})
}
if (res.returnValue.count === 0) {
this.notFirstLoad = true
} else {
this.notFirstLoad = false
}
if (res.returnValue.list.length === 0 || res.returnValue.count < this.rows) {
this.loadMoreDom.innerText = '我也是有底线的～o～'
setTimeout(() => {
this.loadMoreDom.style.display = 'none'
}, 2000)
}
done && done()
})
}
} else {
getDealList({
accountid: this.accountid,
dealstatus: parseInt(this.select) + 1,
owner_type: config.owner_type,
sourcetype: 1,
page: this.page,
rows: this.rows
}).then(res => {
if (type === 'refresh') {
this.declareList = []
this.listDom.scrollTop = 0
}
if (res.returnValue.list !== '' && res.returnValue.list.length > 0) {
res.returnValue.list.forEach(item => {
this.declareList.push({
createdate: item.createdate,
title: item.title,
id: item.id,
status: item.status,
statusNAME: item.statusNAME,
dealmsg: item.dealmsg,
dealdate: item.dealdate
})
if (item.dealfileids && item.dealfileids != '') {
let arr = item.dealfileids.split(';')
arr.forEach(i => {
this.upimglist.push({ i })
})
}
})
}
if (res.returnValue.count === 0) {
this.notFirstLoad = true
} else {
this.notFirstLoad = false
}
if (res.returnValue.list.length === 0 || res.returnValue.count < this.rows) {
this.loadMoreDom.innerText = '我也是有底线的～o～'
setTimeout(() => {
this.loadMoreDom.style.display = 'none'
}, 2000)
}
done && done()
})
}
},
gopath () {
this.$router.push({ name: 'declare' })
},
onItemClick (index) {
this.$router.push({ name: 'myMailWorkDaiban', params: { selected: 2, tabIndex: index } })
},
reply (id) {
this.$router.push({ name: 'myReply', params: { id: id } })
},
godetail (id, index) {
this.$router.push({ name: 'myDetailWork', params: { id: id, select: index } })
},

refresh (done) {
this.page = 1
this.loadMoreDom.innerText = '加载中...'
this.getlist('refresh', done)
},

loadMore (done) {
this.page++
this.getlist('more', done)
}
},
activated () {
this.listDom.scrollTop = config.scrollPosition.y
},
beforeRouteLeave (to, from, next) {
config.scrollPosition.y = this.listDom.scrollTop
next()
},
created () {
this.getlist('refresh')
},
beforeRouteUpdate (to, from, next) {
next()
this.id = this.$route.params.tabIndex
this.select = this.id





}
}
